import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  mediaService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'exportedMediaModel',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      webApiSettings,
      ExportedMedia
    ) {
      'use strict';

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          return {
            status_code: status,
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
        }

        if (err.ModelState) {
          return {
            title: $filter('translate')('ERROR'),
            text: $filter('translate')('VERIFY FIELD ERRORS'),
            modelState: err.ModelState,
          };
        }

        return {
          title: $filter('translate')('ERROR'),
          text: $filter('translate')('ERROR SAVING CONTRACT'),
        };
      }

      function sortColumns() {
        return {
          column: 'dateStarted',
          title: 'MEDIA START DATE',
          type: 'date',
          sortOrder: 'desc',
        };
      }

      function list() {
        var deferred = $q.defer();

        var url = 'medias';

        $http.get(webApiSettings.apiServiceBaseUri + url).then(
          function (res) {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            data.forEach(function (item) {
              result.push(new ExportedMedia(item));
            });

            deferred.resolve(result);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function save(exportedMedia) {
        var deferred = $q.defer();

        var url = 'medias';

        $http.post(webApiSettings.apiServiceBaseUri + url, exportedMedia).then(
          function () {
            deferred.resolve(true);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function _delete(item) {
        var deferred = $q.defer();

        var url = 'medias/';

        $http.delete(webApiSettings.apiServiceBaseUri + url + item.id).then(
          function (res) {
            deferred.resolve(res);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function download(item) {
        var deferred = $q.defer();

        var url = 'medias/';

        $http
          .get(
            webApiSettings.apiServiceBaseUri + url + item.id + '/downloadurl'
          )
          .then(
            function (res) {
              var data = res.data;

              deferred.resolve(data);
            },
            function (err) {
              deferred.reject(handleError(err.data, err.status));
            }
          );

        return deferred.promise;
      }

      function run() {
        try {
          var mediaFactory = {};

          mediaFactory.sortColumns = logWrapper(
            sortColumns,
            runtimeConstant.isDebugServicesInternals
          );
          mediaFactory.list = logWrapper(
            list,
            runtimeConstant.isDebugServicesInternals
          );
          mediaFactory.save = logWrapper(
            save,
            runtimeConstant.isDebugServicesInternals
          );
          mediaFactory.delete = logWrapper(
            _delete,
            runtimeConstant.isDebugServicesInternals
          );
          mediaFactory.download = logWrapper(
            download,
            runtimeConstant.isDebugServicesInternals
          );

          return mediaFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
